import { type GuestWithStatus } from "@/store/useRegistrationData";

interface StoragedGuestsInfo {
  updateAt: string;
  guestWithStatusList: GuestWithStatus[];
}
const defaultGuestsInfo: StoragedGuestsInfo = {
  updateAt: "",
  guestWithStatusList: [],
};

export const getStoragedGuestsInfo = (signedOrderId: string) => {
  const storagedGuestsInfo = localStorage.getItem(signedOrderId);
  if (storagedGuestsInfo) {
    try {
      return (
        (JSON.parse(storagedGuestsInfo) as StoragedGuestsInfo) ||
        defaultGuestsInfo
      );
    } catch (error) {
      return defaultGuestsInfo;
    }
  }
  return defaultGuestsInfo;
};

export const setStoragedGuestsInfo = (
  signedOrderId: string,
  guestsInfo: StoragedGuestsInfo,
) => {
  localStorage.setItem(signedOrderId, JSON.stringify(guestsInfo));
};
